export default __webpack_public_path__ + "static/media/product_5.aca0193b.webp";